// extracted by mini-css-extract-plugin
var _1 = "InputValidationStyles-module__details___FlyF2";
var _2 = "InputValidationStyles-module__error___mBcym";
export { _1 as "details", _2 as "error" }
